var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVendors(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.216,
    height: 50.351,
    viewBox: "0 0 46.216 50.351",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5694",
    "data-name": "Group 5694",
    transform: "translate(-1352.25 -112.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6884",
    "data-name": "Path 6884",
    d: "M36.078,23.674V21.607h4.135L21.607,3,3,21.607H7.135V36.078a4.135,4.135,0,0,0,4.135,4.135h9.889m-5.754,0v-12.4a4.135,4.135,0,0,1,4.135-4.135h4.135a4.135,4.135,0,0,1,4.135,4.135",
    transform: "translate(1350 110)",
    fill: "none",
    stroke: "#dde4eb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6886",
    "data-name": "Path 6886",
    d: "M10.368,17.736l7.368-7.368m-6.754.614-.614,0a.614.614,0,1,0,.614-.614.614.614,0,0,0-.614.614m6.754,6.14-.614,0a.614.614,0,1,0,.614-.614.614.614,0,0,0-.614.614m-2.456-3.07M3,14.052A11.052,11.052,0,1,0,14.052,3,11.052,11.052,0,0,0,3,14.052",
    transform: "translate(1372.612 136.748)",
    fill: "none",
    stroke: "#dde4eb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendors);
export default __webpack_public_path__ + "static/media/vendors.64f8a777.svg";
export { ForwardRef as ReactComponent };